import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren } from "react";
import { useNavigate } from "react-router";

interface Props {
    target: string;
    className?: string;
}

const useStyles = makeStyles({
    shortcut: {
        cursor: "pointer"
    }
});

const QATableShortcut: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();
    const navigate = useNavigate();

    return (
        <div
            className={clsx(classes.shortcut, props.className)}
            onClick={() => navigate(props.target)}>
            {props.children}
        </div>
    );
};

export default QATableShortcut;
